import type { HTMLAttributes, ReactNode } from "react";
import styles from "./AlignedContent.module.css";

type AlignedContentProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
};

const AlignedContent = ({ children, className, ...props }: AlignedContentProps) => (
  <div className={[styles.alignedContent, className].filter(Boolean).join(" ")} {...props}>
    {children}
  </div>
);

export default AlignedContent;
